import moment from "moment";
import { decryptData } from "./helper";

const flattenArray = (arr) => {
  // Recursively flatten the array
  return arr.reduce((acc, item) => {
    if (Array.isArray(item)) {
      // Recursively flatten nested arrays
      return acc.concat(flattenArray(item));
    } else {
      return acc.concat(item);
    }
  });
};

export const decryptPatientData = async(patient) => {
  const decryptedMembers = patient?.relationship
  ? await Promise.all(
      patient?.relationship?.map(async (member) => ({
        "fullName": await decryptData(member.fullName),
        "relationship": member.relationship ? await decryptData(member.relationship) : null,
        "dob": member.dob ? await decryptData(member.dob) : null,
        "dependent": member.dependent
      }))
    )
  : [];

  // const decryptedDocuments = patient?.documents
  // ? await Promise.all(
  //     patient?.documents?.map(async (doc) => ({
  //       documentTitle: doc?.documentTitle && await decryptData(doc.documentTitle),
  //       filePath: {
  //         key:  doc?.filePath?.key,
  //         publicUrl: doc?.filePath?.publicUrl
  //       },
  //       expirationDate: doc?.expirationDate && decryptData(doc.expirationDate),
  //       documentType: doc?.documentType && await decryptData(doc.documentType),
  //       title: doc?.title && await decryptData(doc.title),
  //       _id: doc?._id,
  //       uploadDate: await decryptData(doc.uploadDate)
  //     }))
  //   )
  // : [];
  const emergencyContacts = patient?.emergencyContacts || {};

  const decryptedEmergencyContacts = {
    name: emergencyContacts.name ? await decryptData(emergencyContacts.name) : null,
    relationship: emergencyContacts.relationship ? await decryptData(emergencyContacts.relationship) : null,
    phone: emergencyContacts.phone ? await decryptData(emergencyContacts.phone) : null,
    secondaryPhone: emergencyContacts.secondaryPhone ? await decryptData(emergencyContacts.secondaryPhone) : null,
    email: emergencyContacts.email ? await decryptData(emergencyContacts.email) : null,
    languagePreference: Array.isArray(emergencyContacts.languagePreference)
      ? flattenArray(await Promise.all(emergencyContacts.languagePreference.map(async (lang) => await decryptData(lang))))
      : emergencyContacts.languagePreference ? flattenArray([await decryptData(emergencyContacts.languagePreference)]) : [],
    preferredContactMethod: Array.isArray(emergencyContacts.preferredContactMethod)
      ? flattenArray(await Promise.all(emergencyContacts.preferredContactMethod.map(async (method) => await decryptData(method))))
      : emergencyContacts.preferredContactMethod ? flattenArray([await decryptData(emergencyContacts.preferredContactMethod)]) : [],
    alternateName: emergencyContacts.alternateName ? await decryptData(emergencyContacts.alternateName) : null,
    alternateReln: emergencyContacts.alternateReln ? await decryptData(emergencyContacts.alternateReln) : null,
    alternatePhone: emergencyContacts.alternatePhone ? await decryptData(emergencyContacts.alternatePhone) : null,
    alternateSecondaryPhone: emergencyContacts.alternateSecondaryPhone ? await decryptData(emergencyContacts.alternateSecondaryPhone) : null,
    alternateEmail: emergencyContacts.alternateEmail ? await decryptData(emergencyContacts.alternateEmail) : null,
    alternatelanguagePreference: Array.isArray(emergencyContacts.alternatelanguagePreference)
      ? flattenArray(await Promise.all(emergencyContacts.alternatelanguagePreference.map(async (lang) => await decryptData(lang))))
      : emergencyContacts.alternatelanguagePreference ? flattenArray([await decryptData(emergencyContacts.alternatelanguagePreference)]) : [],
    alternatepreferredContactMethod: Array.isArray(emergencyContacts.alternatepreferredContactMethod)
      ? flattenArray(await Promise.all(emergencyContacts.alternatepreferredContactMethod.map(async (method) => await decryptData(method))))
      : emergencyContacts.alternatepreferredContactMethod ? flattenArray([await decryptData(emergencyContacts.alternatepreferredContactMethod)]) : []
  };
  const patientData = {
    ...patient,
    name: {
      text: decryptData(patient?.name[0].text)
    },
    telecom: [
      {
        system: patient?.telecom[0].system,
        value: patient?.telecom[0].value && decryptData(patient?.telecom[0].value),
        use: patient?.telecom[0].use
      },
      {
        system: patient?.telecom[1]?.system && patient?.telecom[1]?.system,
        value: patient?.telecom[1]?.value && decryptData(patient?.telecom[1]?.value),
        use: patient?.telecom[1]?.use
      },
      ...(patient?.telecom[2]
        ? [{
            system: patient?.telecom[2]?.system,
            value: decryptData(patient?.telecom[2]?.value),
            use: patient?.telecom[2]?.use
          }]
        : [])
    ],
    gender: patient?.gender && decryptData(patient?.gender),
    birthDate: patient?.birthDate && decryptData(patient?.birthDate),
    role: patient?.role && decryptData(patient?.role),
    address: {
      use: patient?.address[0]?.use,
      line: patient?.address[0]?.line[0] && decryptData(patient?.address[0]?.line[0]),
      city:patient?.address[0]?.city &&  decryptData(patient?.address[0]?.city),
      state:  patient?.address[0]?.state && decryptData(patient?.address[0]?.state),
      postalCode: patient?.address[0]?.postalCode && decryptData(patient?.address[0]?.postalCode)
    },
    insuranceDetails:{
      beneficiaryName: patient?.insuranceDetails?.beneficiaryName && decryptData(patient?.insuranceDetails?.beneficiaryName),
      company: patient?.insuranceDetails?.company && decryptData(patient?.insuranceDetails?.company),
      policyNumber: patient?.insuranceDetails?.policyNumber && decryptData(patient?.insuranceDetails?.policyNumber),
      groupNumber: patient?.insuranceDetails?.groupNumber && decryptData(patient?.insuranceDetails?.groupNumber),
      planType: patient?.insuranceDetails?.planType && decryptData(patient?.insuranceDetails?.planType),
      effectiveDate: patient?.insuranceDetails?.effectiveDate && decryptData(patient?.insuranceDetails?.effectiveDate),
      alternateBeneficiaryName: patient?.insuranceDetails?.alternateBeneficiaryName && decryptData(patient?.insuranceDetails?.alternateBeneficiaryName),
      alternateCompany: patient?.insuranceDetails?.alternateCompany && decryptData(patient?.insuranceDetails?.alternateCompany),
      alternatePolicyNumber: patient?.insuranceDetails?.alternatePolicyNumber && decryptData(patient?.insuranceDetails?.alternatePolicyNumber),
      alternateGroupNumber: patient?.insuranceDetails?.alternateGroupNumber && decryptData(patient?.insuranceDetails?.alternateGroupNumber),
      alternatePlanType: patient?.insuranceDetails?.alternatePlanType && decryptData(patient?.insuranceDetails?.alternatePlanType),
      alternateEffectiveDate: patient?.insuranceDetails?.alternateEffectiveDate && decryptData(patient?.insuranceDetails?.alternateEffectiveDate)
    },
    maritalStatus: patient?.maritalStatus && decryptData(patient?.maritalStatus),
    medicaidEnrollmentStatus: patient?.medicaidEnrollmentStatus,
    medicaidDeniedReason: patient?.medicaidDeniedReason && decryptData(patient?.medicaidDeniedReason),
    medicaidDeniedCode: patient?.medicaidDeniedCode,
    relationship: decryptedMembers,
    documents: [],
    isVeterian: patient?.isVeterian,
    isPregnant: patient?.isPregnant,
    isDisable: patient?.isDisable,
    isLegalImmigrant: patient?.isLegalImmigrant,
    isQualifiedSSN: patient?.isQualifiedSSN,
    isUsCitizen : patient?.isUsCitizen,
    houseHoldSize:  patient?.houseHoldSize && decryptData(patient?.houseHoldSize),
    houseHoldIncome: patient?.houseHoldIncome && decryptData(patient?.houseHoldIncome),
    socialSecurityNumber: patient?.socialSecurityNumber && decryptData(patient?.socialSecurityNumber),
    medicaidElegibitlyGroup: patient?.medicaidElegibitlyGroup && patient?.medicaidElegibitlyGroup,
    taxPayerNumber: patient?.taxPayerNumber && decryptData(patient?.taxPayerNumber),
    departmentAprvlStatus: patient?.departmentAprvlStatus,
    mrnNumber: patient?.mrnNumber && decryptData(patient?.mrnNumber),
    emergencyContacts:decryptedEmergencyContacts,
    doa: patient?.doa && decryptData(patient?.doa),
    patientPortalNote: patient?.patientPortalNote && decryptData(patient?.patientPortalNote),
    patientNote: patient?.patientNote && decryptData(patient?.patientNote),
    permissions: patient?.permissions,
    staffId: patient?.staffId,
    ai_care: patient?.ai_care,
    discharged_status: patient?.discharged_status,
    applications: patient?.applications,
    applied_income_limit : patient?.applied_income_limit,
    applied_fpl_percentage : patient?.applied_fpl_percentage,
    eligibility_group_applied : patient?.eligibility_group_applied
  };
  return patientData;
};

export const applyFilters = (filters, data, type) => {
  let result = data || [];

  const filteredResults = filters.reduce((acc, filter) => {
    let tempData = acc.length === 0 ? result : acc;

    let applyTypeFilter;
    if (type === 'Application') {
      applyTypeFilter = applyApplicationFieldFilter;

    } else {
      applyTypeFilter = applyFieldFilter;
    }

    if (filter.condition === 'Where' || acc.length === 0) {
      tempData = applyTypeFilter(tempData, filter);
    }
    else if (filter.condition === 'And') {
      tempData = tempData.filter(item => applyTypeFilter([item], filter).length > 0);
    }
    else if (filter.condition === 'Or') {
      const orResults = applyTypeFilter(result, filter);
      tempData = [...new Set([...tempData, ...orResults])];
    }

    return tempData;
  }, result);

  return filteredResults;
};


const applyFieldFilter = (data, filter) => {
  switch (filter.field) {
    case 'household_salary':
      return data.filter(item =>
        filter.operator === 'Less than'
          ? item.houseHoldIncome < parseInt(filter.value)
          : filter.operator === 'Greater than'
          ? item.houseHoldIncome > parseInt(filter.value)
          : filter.operator === 'Is'
          ? item.houseHoldIncome === parseInt(filter.value)
          : filter.operator === 'Is Not'
          ? item.houseHoldIncome !== parseInt(filter.value)
          : false // Fallback case
      );

    case 'household_members':
      return data.filter(item => {
        const householdSize = item.houseHoldSize ? parseInt(item.houseHoldSize) : 0; // Ensure it's a number
        const filterValue = parseInt(filter.value); // Convert filter value to number

        return filter.operator === 'Less than'
          ? householdSize < filterValue
          : filter.operator === 'Greater than'
          ? householdSize > filterValue
          : filter.operator === 'Is'
          ? householdSize === filterValue
          : filter.operator === 'Is Not'
          ? householdSize !== filterValue
          : false; // Fallback case
      });

      case 'patient_name':
        return data.filter(item => {
          const decryptedName = item?.name?.text;
          return applyTextFilter(decryptedName, filter.value, filter.operator);
        });

        case 'discharged_status':
        case 'coverage':
        case 'pregnant':
        case 'disable': {
          const value = filter.value === 'true';
          const key = {
            discharged_status: 'discharged_status',
            coverage: 'coverage',
            pregnant: 'isPregnant',
            disable: 'isDisable'
          }[filter.field];

          return data.filter(item =>
            item[key] === value ? filter.operator !== 'Is Not' : filter.operator === 'Is Not'
          );
        }

      case 'department_approval':
        return data.filter(item =>
          filter.operator === 'Is Not'
            ? item.departmentAprvlStatus !== filter.value
            : item.departmentAprvlStatus === filter.value
        );

    case 'assigned_to':
      return data.filter(item =>
        filter.operator === 'Is Not'
          ? item.staffId !== filter.value
          : item.staffId === filter.value
      );

    case 'stage':
      return data.filter(item => {
        const itemStage = moment(new Date(item.doa)).startOf('day'); // Create moment object for item DOA
        const filterStage = moment(new Date(filter.value)).startOf('day'); // Create moment object for filter value

        return filter.operator === 'Less than'
          ? itemStage.isBefore(filterStage)
          : filter.operator === 'Greater than'
          ? itemStage.isAfter(filterStage)
          : filter.operator === 'Is'
          ? itemStage.isSame(filterStage)
          : filter.operator === 'Is Not'
          ? !itemStage.isSame(filterStage)
          : false; // Fallback case
      });

      case 'medicaid_eligibility':
        return data.filter(item =>
          filter.operator === 'Is Not'
            ? item.system_ai_care !== filter.value
            : item.system_ai_care === filter.value
        );

      case 'group_eligibility':
      return data.filter(item => {
        const group = item.medicaidElegibitlyGroup;

        if (!Array.isArray(group)) return false;

        return filter.operator === 'Is Not'
          ? !group.includes(filter.value)
          : group.includes(filter.value);
      });

        case 'state':
          return data.filter(item =>
            filter.operator === 'Is Not'
              ? item.address?.state !== filter.value
              : item.address?.state === filter.value
          );
    default:
      return data.filter(item => item[filter.field] === filter.value);
  }
};

const applyTextFilter = (fieldValue, filterValue, operator) => {
  const value = (fieldValue || '').toLowerCase();
  const target = filterValue.toLowerCase();

  switch (operator) {
    case 'Contains':
      return value.includes(target);
    case 'Not Contains':
      return !value.includes(target);
    default:
      return value === target; // fallback to exact match
  }
};

const applyApplicationFieldFilter = (data, filter) => {

  switch (filter.field) {
    case 'patient_name':
      return data.filter(item => {
        const decryptedName = decryptData(item.patientData?.name[0]?.text);
        return applyTextFilter(decryptedName, filter.value, filter.operator);
      });

    case 'title':
      return data.filter(item => {
        return applyTextFilter(item.title, filter.value, filter.operator);
      });
    case 'assigned_to':
      return data.filter(item =>
        filter.operator === 'Is Not'
          ? item.consultantUser?._id !== filter.value
          : item.consultantUser?._id === filter.value
      );

      case 'status':
        return data.filter(item =>
          filter.operator === 'Is Not'
            ? item.status!== filter.value
            : item.status=== filter.value
        );

    case 'created_at':
      return data.filter(item => {
        const itemStage = moment(new Date(item.createdAt)).startOf('day');
        const filterStage = moment(new Date(filter.value)).startOf('day');

        return filter.operator === 'Less than'
          ? itemStage.isBefore(filterStage)
          : filter.operator === 'Greater than'
          ? itemStage.isAfter(filterStage)
          : filter.operator === 'Is'
          ? itemStage.isSame(filterStage)
          : filter.operator === 'Is Not'
          ? !itemStage.isSame(filterStage)
          : false; // Fallback case
      });

      case 'group_eligibility':
        return data.filter(item => {
          const group = item.patientData?.medicaidElegibitlyGroup;

          // Ensure group is an array
          if (!Array.isArray(group)) return false;

          return filter.operator === 'Is Not'
            ? !group.includes(filter.value)
            : group.includes(filter.value);
        });

      case 'state':
        return data.filter(item =>
          filter.operator === 'Is Not'
            ? decryptData(item.patientData?.address[0]?.state) !== filter.value
            : decryptData(item.patientData?.address[0]?.state) === filter.value
        );

    default:
      return data.filter(item => item[filter.field] === filter.value);
  }
};

export const applyFiltersSupport = (filters, data) => {

  let result = data || [];

  const filteredResults = filters.reduce((acc, filter) => {
    let tempData = acc.length === 0 ? result : acc;

    if (filter.condition === 'Where' || acc.length === 0) {
      tempData = applySupportFieldFilter(tempData, filter);
    } else if (filter.condition === 'And') {
      tempData = tempData.filter(item => applySupportFieldFilter([item], filter).length > 0);
    } else if (filter.condition === 'Or') {
      const orResults = applySupportFieldFilter(tempData, filter);
      tempData = [...new Set([...tempData, ...orResults])];  // Avoid duplicate items
    }

    return tempData;
  }, result);

  return filteredResults;
};

const applySupportFieldFilter = (data, filter) => {
  const { field, value, condition, operator } = filter;

  return data.filter((item) => {
    let fieldValue = getNestedValue(item, field);

    if (fieldValue === undefined || fieldValue === null) return false;

    // Handle MongoDB ObjectId fields like createdBy.$oid or assignedTo._id
    if (field === "createdBy" || field === "assignedTo") {
      const fieldStr = fieldValue._id;
      const valueStr = value;
      if (operator === "Is Not") return fieldStr !== valueStr;
      if (operator === "Is") return fieldStr === valueStr;
    }
    // Ensure ticketId is treated as a string for comparison
    if (field === "ticketId" || field === "title") {
      const fieldStr = String(fieldValue).toLowerCase();
      const valueStr = String(value).toLowerCase();
      if (operator === "Contains") return fieldStr.includes(valueStr);
      if (operator === "Not Contains") return !fieldStr.includes(valueStr);
      if (condition === "Where") return fieldStr === valueStr;
    }

    // Handle case-insensitive String matching
    if (typeof fieldValue === "string") {
      const fieldLower = fieldValue.toLowerCase();
      const valueLower = value.toLowerCase();

      if (operator === "Is Not") return fieldLower !== valueLower;
      if (operator === "Is") return fieldLower === valueLower;
      if (condition === "Contains") return fieldLower.includes(valueLower);
    }

    // Handle Enum (Exact match or multiple selection)
    if (Array.isArray(value)) {
      return operator === "Is Not" ? !value.includes(fieldValue) : value.includes(fieldValue);
    }

    // Handle Date comparison (Before, After)
    if (field === "createdAt" && !isNaN(new Date(fieldValue))) {
      const dateValue = new Date(fieldValue);
      const filterDate = new Date(value);

      if (condition === "Before") return dateValue <= filterDate;
      if (condition === "After") return dateValue >= filterDate;
      if (operator === "Is Not") return dateValue.getTime() !== filterDate.getTime();
      if (operator === "Is") return dateValue.getTime() === filterDate.getTime();
    }

    return false;
  });
};

// Helper function to retrieve nested object values (e.g., "assignedTo._id" or "createdBy.$oid")
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
};

export const maskEmail = (email) => {
  const [first, domain] = email.split("@");
  return `${first.charAt(0)}****@${domain}`;
};

export const maskPhoneNumber = (phone) => {
  if (!phone || phone.length < 4) return "***-***-****";
  return `***-***-${phone.slice(-4)}`;
};

export const maskString = (string) => {
  if (!string || string.length < 4) return "*".repeat(string?.length || 0);
  const visiblePart = string.slice(-4);
  const maskedPart = "*".repeat(string.length - 4);
  return maskedPart + visiblePart;
};
